import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=70197439&scoped=true"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=70197439&prod&scoped=true&lang=css"
import style1 from "./Bookings.vue?vue&type=style&index=1&id=70197439&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70197439",
  null
  
)

export default component.exports